import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-privacidad',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './privacidad.html',
  styleUrl: './privacidad.scss'
})
export class PrivacidadComponent {
  siteConfig = environment.siteConfig;

  constructor(private dialogRef: MatDialogRef<PrivacidadComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
